import styles from "./PortalShellPageHeader.module.css";

export default function PortalShellPageHeader({
  icon,
  title,
  subtitle,
  children,
  variant = "default",
}) {
  if (variant === "intro") {
    return (
      <header className={styles.rootIntro}>
        <h1 className={styles.introTitle}>{title}</h1>
        {subtitle != null && subtitle !== "" ? (
          <p className={styles.introLead}>{subtitle}</p>
        ) : null}
        {children ? <div className={styles.introExtras}>{children}</div> : null}
      </header>
    );
  }

  return (
    <header className={styles.root}>
      <div className={styles.top}>
        <span className={styles.iconSlot} aria-hidden="true">
          {icon}
        </span>
        <h1 className={styles.title}>{title}</h1>
      </div>
      {subtitle != null && subtitle !== "" ? (
        <p className={styles.subtitle}>{subtitle}</p>
      ) : null}
      {children ? <div className={styles.extras}>{children}</div> : null}
      <hr className={styles.rule} aria-hidden="true" />
    </header>
  );
}
